import React, {useEffect, useState} from "react"
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import {
  Card,
  CardBody,
  Col,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner,
  Button
} from "reactstrap"
import * as moment from "moment"
import { AvField, AvForm } from "availity-reactstrap-validation";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";
import { showSuccessToast } from "helpers/function_helper"
import { getPublicHolidayList, addNewHoliday } from "helpers/backend_helper"
import { getPublicHolidayListFromCache } from "helpers/cache_helper"

import "@fullcalendar/bootstrap/main.css";
import DeleteModal from "./DeleteModal";
import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import { deleteItemDirect as onDeleteItemDirect } from "helpers/backend_helper"

const HolidayCalendar = props => {

  const dispatch = useDispatch()
  const [events, setEvents] = useState([]);
  const [selectedDay, setSelectedDay] = useState(0);
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [event, setEvent] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalHolidaySeries, setModalHolidaySeries] = useState(false);
  const [showNoDateError, setShowNoDateError] = useState(false);

  useEffect(() => {
    if (!modal && !isEmpty(event) && !!isEdit) {
      setTimeout(() => {
        setEvent({});
        setIsEdit(false);
      }, 500);
    }
  }, [modal, event]);

  useEffect(() => {
    getPublicHolidays()
  }, [dispatch]);

  const toggle = () => {
    setModal(!modal);
  };

  const toggleHolidaySeries = () => {
    setModalHolidaySeries(!modalHolidaySeries);
  };

  async function getPublicHolidays(){
    const holidays = await getPublicHolidayListFromCache(true)
    if(holidays && holidays.length > 0){
      setEvents(convertToCalVO(holidays))
    }
  }

  function getAllDays(dayIndex, startDate, endDate) {
    /*
    var today = new Date(startDate)
    today.setDate(today.getDate()-1);
    today.setDate(today.getDate() + (dayIndex - 1 - today.getDay() + 7) % 7 + 1);
    return today;
    */
    var today = new Date(startDate)
    today.setDate(today.getDate()-1);

    var lastday = new Date(endDate)
    lastday.setDate(lastday.getDate()+1);

    var start = moment(today);
    var end   = moment(lastday);
    var result = [];
    var current = start.clone();
    //console.log('current::',current.day(7 + dayIndex).isBefore(end))
    while (current.day(7 + dayIndex).isBefore(end)) {
      result.push(current.clone());
    }
    return result.map(m => m.format('yyyy-MM-DD'))
  }

  const handleValidEventSubmitcategory = async (event, values) => {
    setShowNoDateError(false)
    const day = values["day"];
    const startDate = values["startDate"];
    const endDate = values["endDate"];

    const allDays = getAllDays(Number(day), startDate, endDate);
    //console.log('allDays',allDays);

    if(allDays.length == 0){
      setShowNoDateError(true)
      return
    }

    const newEvent = {
      holidaytitle: values["title"],
      holidaytype: "phs",
      holidaydate: allDays.toString(),
      holidayclazz: "bg-warning" + " text-white",
    };
    // save new event
    setShowLoading(true)
    const result = await addNewHoliday(newEvent)
    setShowLoading(false)
    if(result && result.status == 'success'){
      toggleHolidaySeries()
      showSuccessToast('Added Successfully!!!')
      getPublicHolidayListFromCache(false).then(resp => {
        if(resp && resp.length > 0){
          setEvents(convertToCalVO(resp))
        }
      })
    }
  };

  const handleValidEventSubmit = async (e, values) => {
    
    if (isEdit) {

      const date = event['holidaydate'];
      const updateEvent = {
        value: event.value,
        holidaytitle: values.title,
        holidaytype: "ph",
        holidayclazz: "bg-warning" + " text-white",
        holidaydate: date
      };
      // update event
      //dispatch(onUpdateEvent(updateEvent));
      setShowLoading(true)
      const response = await onEditItemDirect(updateEvent, 'PHoliday')
      setShowLoading(false)
      if(response.status == 'success'){
        showSuccessToast('Edited Successfully!!!')
        getPublicHolidayListFromCache(false).then(resp => {
          if(resp && resp.length > 0){
            setEvents(convertToCalVO(resp))
          }
        })
      }
    } else {

      const newEvent = {
        holidaytitle: values["title"],
        holidaytype: "ph",
        holidaydate: selectedDay ? selectedDay.dateStr + "" : new Date(),
        holidayclazz: "bg-warning" + " text-white",
      };
      // save new event
      setShowLoading(true)
      const result = await addNewHoliday(newEvent)
      setShowLoading(false)
      if(result.status == 'success'){
        
        showSuccessToast('Added Successfully!!!')
        getPublicHolidayListFromCache(false).then(resp => {
          if(resp && resp.length > 0){
            setEvents(convertToCalVO(resp))
          }
        })
      }
      //dispatch(onAddNewEvent(newEvent));
    }
    setSelectedDay(null);
    toggle();
  };

  function convertToCalVO(inp){
    const converted = []
    inp.map(each => {
      converted.push({
        id: each.value,
        title: each.holidaytitle,
        type: each.holidaytype,
        //start: new Date(each.holidaydate),
        start: each.holidaydate,
        className: each.holidayclazz,
      })
    })
    return converted;
  }

  const handleDeleteEvent = async () => {
   // dispatch(onDeleteEvent(event));
   setDeleteModal(false);
   setShowLoading(true)
    const response =  await onDeleteItemDirect({
      'key': event.value,
      'value' : 'PHoliday'
    }, '')
    setShowLoading(false)
    
    if(response.status == 'success'){
        
      showSuccessToast('Deleted Successfully!!!')
      getPublicHolidayListFromCache(false).then(resp => {
        if(resp && resp.length > 0){
          setEvents(convertToCalVO(resp))
        }
      })
    }
    toggle();
  };

  const handleDateClick = arg => {
    const date = arg["date"];
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    const currectDate = new Date();
    const currentHour = currectDate.getHours();
    const currentMin = currectDate.getMinutes();
    const currentSec = currectDate.getSeconds();
    const modifiedDate = new Date(
      year,
      month,
      day,
      currentHour,
      currentMin,
      currentSec
    );
    const modifiedData = { ...arg, date: modifiedDate };
    setSelectedDay(modifiedData);
    toggle();
  };

  const handleEventClick = arg => {
    const event = arg.event;
    /**
     * id: each.value,
        title: each.holidaytitle,
        type: each.holidaytype,
        //start: new Date(each.holidaydate),
        start: each.holidaydate,
        className: each.holidayclazz,
     */
    setEvent({
      value: event.id,
      holidaytitle: event.title,
      holidaytype: event.type,
      holidaydate: event.startStr,
      className: event.classNames[0] + " " +event.classNames[1],
    });
    //console.log('event:',event)
    setIsEdit(true);
    toggle();
  };

  function isNumber(num){
    if(Number(num) || num == 0){
      return true;
    }
    else{
      return false;
    }
  }


  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteEvent}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Row className="mt-3">
        <Col lg="12">
          <Card>
            <CardBody>
              <Row>
                <Col>
                <p className="text-muted">
                  Click on the date to add a new Holiday
                </p>
                </Col>
              </Row>
              <Row>

                <Col md={2}>
                  <Button
                    color="info"
                    className="font-16 btn-block"
                    onClick={toggleHolidaySeries}
                  >
                    <i className="mdi mdi-plus-circle-outline me-1" />
                    Add Holiday Series
                  </Button>
                </Col>

                <Col md={10}>
                  <FullCalendar
                    plugins={[
                      BootstrapTheme,
                      dayGridPlugin,
                      interactionPlugin,
                    ]}
                    //slotDuration={"00:15:00"}
                    handleWindowResize={true}
                    themeSystem="bootstrap"
                    contentHeight="auto"
                    headerToolbar={{
                      left: "prev,next today",
                      center: "title",
                      right: "dayGridMonth,dayGridWeek,dayGridDay",
                    }}
                    events={events}
                    editable={true}
                    droppable={false}
                    selectable={true}
                    dateClick={handleDateClick}
                    eventClick={handleEventClick}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Modal isOpen={modal} className={props.className}>
        <ModalHeader toggle={toggle} tag="h4">
          {!!isEdit ? "Edit Holiday" : "Add Holiday"}
        </ModalHeader>
        <ModalBody>
          <AvForm onValidSubmit={handleValidEventSubmit}>
            <Row form>
              <Col className="col-12 mb-3">
                <AvField
                  name="title"
                  label="Holiday"
                  type="text"
                  errorMessage="Invalid holiday"
                  validate={{
                    required: { value: true },
                  }}
                  value={event ? event.holidaytitle : ""}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    onClick={toggle}
                  >
                    Close
                  </button>
                  {!!isEdit && (
                    <button
                      type="button"
                      disabled={showLoading}
                      className="btn btn-danger me-2"
                      onClick={() => setDeleteModal(true)}
                    >
                      Delete
                      {showLoading && <Spinner style={{ width: '1.0rem', height: '1.0rem' }} className="ms-1" color="primary" />}
                    </button>
                  )}
                  <button
                    type="submit"
                    disabled={showLoading}
                    className="btn btn-success save-event"
                  >
                    Save
                    {showLoading && <Spinner style={{ width: '1.0rem', height: '1.0rem' }} className="ms-1" color="primary" />}
                  </button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={modalHolidaySeries}
        toggle={toggleHolidaySeries}
        className={props.className}
      >
        <ModalHeader toggle={toggleHolidaySeries} tag="h4">
          Add a Holiday Series
        </ModalHeader>
        <ModalBody>
          <AvForm
            onValidSubmit={handleValidEventSubmitcategory}
          >
            <Row form>
              <Col className="col-12 mb-3">
                <AvField
                  name="title"
                  label="Holiday"
                  type="text"
                  errorMessage="Invalid holiday"
                  validate={{
                    required: { value: true },
                  }}
                />
              </Col>
              <Col className="col-12 mb-3">
                <AvField
                  name="startDate"
                  label="From Date"
                  type="date"
                  errorMessage="Invalid Start Date"
                  validate={{
                    required: { value: true },
                  }}
                />
              </Col>
              <Col className="col-12 mb-3">
                <AvField
                  name="endDate"
                  label="To Date"
                  type="date"
                  errorMessage="Invalid End Date"
                  validate={{
                    required: { value: true },
                  }}
                />
              </Col>
              <Col className="col-12 mb-3">
                <AvField
                  type="select"
                  name="day"
                  label="Choose a day"
                  errorMessage="Select a day"
                  validate={{
                    required: { value: true },
                  }}
                >
                  <option value="">-Select-</option>
                  <option value="0">Sunday</option>
                  <option value="1">Monday</option>
                  <option value="2">Tuesday</option>
                  <option value="3">Wednesday</option>
                  <option value="4">Thursday</option>
                  <option value="5">Friday</option>
                  <option value="6">Saturday</option>
                </AvField>
              </Col>
            </Row>
            {showNoDateError && 
            <Row>
              <Col className="text-danger">
                Nothing to add. Please check the dates
              </Col>
            </Row>
            }
            <Row>
              <Col>
                <div className="text-end">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    onClick={toggleHolidaySeries}
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    disabled={showLoading}
                    className="btn btn-success save-event"
                  >
                    Save
                    {showLoading && <Spinner style={{ width: '1.0rem', height: '1.0rem' }} className="ms-1" color="primary" />}
                  </button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </ModalBody>
      </Modal>

    </React.Fragment>
  )
}

HolidayCalendar.propTypes = {
}

export default HolidayCalendar
